import { createStore } from "redux";
import RootReducer from "./state";

const store = createStore(RootReducer);

export default store;
